const donateFaq = () => {
  const faq = document.querySelector('.faq__list');

  if (faq) {
    const faqItems = faq.querySelectorAll('.faq__item');

    faq.addEventListener('click', function (evt) {
      faqItems.forEach((item) => {
        if (evt.target === item || evt.target.parentNode === item) {
          item.classList.toggle('faq__item--active');
        }
      });
    });
  }
};

export {donateFaq};
